import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Star } from 'lucide-react';
export const TransformationSection = () => {
  return <section className="bg-terracotta text-white px-4 py-10 md:py-20 lg:px-8" data-id="element-249">
      <div className="mx-auto max-w-5xl" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-251">
          <h2 className="mb-8 font-serif text-3xl font-bold md:text-5xl" data-id="element-252">
            Mi Garantía de "Cena en Paz"
          </h2>
          <div className="mx-auto max-w-3xl space-y-6 text-lg leading-relaxed md:text-xl" data-id="element-253">
            <p data-id="element-254">
              No quiero tu dinero si no recuperas tu tiempo. Tienes 7 días
              completos para probar el método. Si tu familia no cree que la
              comida es fresca, o si simplemente no sientes que has recuperado
              tus noches, envíame un correo y te devuelvo tus $9.98 de
              inmediato. Sin preguntas y sin resentimientos.
            </p>
          </div>

          <div className="mt-8 flex items-center justify-center space-x-2 text-lg font-medium text-highlight" data-id="element-255">
            <ShieldCheck className="h-6 w-6" data-id="element-256" />
            <span data-id="element-257">Garantía de Devolución de 7 Días</span>
          </div>

          <a href="#mid-pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('mid-pricing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="group mt-8 inline-flex items-center justify-center rounded-full bg-white px-8 py-4 text-lg font-bold text-terracotta shadow-lg transition-all hover:bg-gray-100 hover:shadow-xl hover:-translate-y-0.5" data-id="element-258">
            OBTENER ACCESO INSTANTÁNEO AL PROTOCOLO
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-259" />
          </a>
        </motion.div>

        {/* Testimonial Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl rounded-2xl bg-white/10 p-8 backdrop-blur-sm md:p-10" data-id="element-260">
          <div className="mb-6 flex justify-center space-x-1" data-id="element-261">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" data-id="element-262" />)}
          </div>

          <blockquote className="mb-6 text-center text-lg italic leading-relaxed text-white/90 md:text-xl" data-id="element-263">
            "¡Maravilloso! Soy nueva en la preparación de comidas, pero como
            mamá trabajadora, necesitaba ayuda. Me encanta cocinar pero no tengo
            tiempo. Esta guía no solo me hizo la vida más fácil; ¡a mi hijo
            súper quisquilloso le encantan casi todos los platos! El Escudo de
            Frescura realmente hace que la comida sepa como si acabara de
            hacerse desde cero."
          </blockquote>

          <div className="text-center font-bold text-highlight" data-id="element-264">
            — Claudia, compradora del Paquete Completo.
          </div>
        </motion.div>
      </div>
    </section>;
};